import { AuroraAssetGroup, AuroraAwhpEvent } from '../types'
import { Chip, ChipProps, Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'

export interface AuroraAssetGroupDefrostStatusChipProps extends Omit<ChipProps, 'label' | 'color'> {
  auroraAssetGroup: AuroraAssetGroup
  auroraAwhpActiveEvents: Record<string, AuroraAwhpEvent[]>
}

export default function AuroraAssetGroupDefrostStatusChip({
  auroraAssetGroup,
  auroraAwhpActiveEvents,
  ...props
}: AuroraAssetGroupDefrostStatusChipProps) {
  const { t } = useTranslation('aurora')

  const defrostingCount = Object.keys(auroraAwhpActiveEvents).filter((auroraId) =>
    auroraAwhpActiveEvents[auroraId].some((event) => event.key === 'DEFROST')
  ).length

  if (defrostingCount === 0) {
    return null
  }

  return (
    <Tooltip title={t('defrosting')}>
      <Chip
        variant="outlined"
        label={`${defrostingCount} ${t('defrosting').toLowerCase()}`}
        color="info"
        {...props}
      />
    </Tooltip>
  )
}
